import { Link } from 'react-router'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

const NotFound = () => {
  useDocumentTitle('Page Not Found')
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-foreground mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-8">Page not found</p>
        <Link to="/" className="inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600">
          Go Home
        </Link>
      </div>
    </div>
  )
}

export default NotFound
